import { ColorTypeEnum } from 'app/models';

export class ColorTypeSelection {
    public static ColorTypeList: Array<any> = [
        { name: 'Dark Blue', value: ColorTypeEnum.DarkBlue },
        { name: 'Red', value: ColorTypeEnum.Red },
        { name: 'Yellow', value: ColorTypeEnum.Yellow },
        { name: 'Green', value: ColorTypeEnum.Green },
        { name: 'Silver', value: ColorTypeEnum.Silver },
        { name: 'Brown', value: ColorTypeEnum.Brown },
        { name: 'White', value: ColorTypeEnum.White },
        { name: 'Black', value: ColorTypeEnum.Black },
        { name: 'Orange', value: ColorTypeEnum.Orange },
        { name: 'Purple', value: ColorTypeEnum.Purple },
        { name: 'Blue', value: ColorTypeEnum.Blue },
        { name: 'Maroon', value: ColorTypeEnum.Maroon },
        { name: 'Dark Green', value: ColorTypeEnum.DarkGreen },
        { name: 'Gray', value: ColorTypeEnum.Gray },
        { name: 'Bronze', value: ColorTypeEnum.Bronze },
        { name: 'Magenta', value: ColorTypeEnum.Magenta },
        { name: 'Light Blue', value: ColorTypeEnum.LightBlue }
    ];
}
